import styled from 'styled-components';

export const Dashboard = styled.div`
  &.isFetching{
    opacity:0.5;
  }
`;